<template>
  <div class="card">
    <!-- <div class="card-header"></div> -->
    <div class="card-body">
      <vue-tabs v-model="oselTab" direction="horizontal" @tab-change="getTabData">
        <v-tab :title="rd.value" v-for="(rd, index) in rawDataList" v-bind:key="index">
          <!-- <Issues
            :rawDataType="rawDataType"
            :comp="company"
            :tableFields="tableFields"
            :rows="tableRows"
            :issuesData="rawData"
          />-->
          <div class="row mb5 mt15">
            <div class="col-md-10"></div>
            <div class="col-md-2" v-if="rawData.length>0">
              <download :tableId="rawDataType" :fileName="rawDataType"></download>
            </div>
          </div>
          <div class="table-responsive scrollbar app" v-dragscroll="true">
            <table :id="rawDataType" class="table table-bordered fonts11 app-inner">
              <thead v-if="rawData.length>0">
                <tr>
                  <th>Sr.</th>
                  <th
                    v-for="(tc, index) in tableFields"
                    v-bind:key="index+'tc'+tc.title"
                  >{{tc.name}}</th>
                </tr>
              </thead>
              <tbody v-if="rawData.length>0">
                <tr v-for="(tr, ind) in rawData" v-bind:key="'trBod'+'-'+ind">
                  <td>{{ind+1}}</td>
                  <td v-for="(cl, index) in tableFields" v-bind:key="index+'cldata'+cl.title">
                    <!-- {{cl.orgKey}}{{[cl.title]}}{{[ind]}} {{tr[cl.title]}} -->
                    <span
                      v-if="cl.title==='OPENDATE' || cl.title==='CLOSDATE'"
                    >{{(tr[cl.title])? getDateTime(tr[cl.title]): '-'}}</span>
                    <span
                      v-else-if="cl.title==='Date'"
                    >{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                    <span v-else-if="cl.type && cl.type==='boolean'">{{(tr[cl.title])? 'Yes': 'No'}}</span>
                    <span
                      v-else-if="cl.type && cl.type==='date'"
                    >{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                    <span
                      v-else-if="cl.type && cl.type==='datetime'"
                    >{{(tr[cl.title])? getDateTime(tr[cl.title]): '-'}}</span>
                    <span v-else>
                      <span v-if="cl.isNumeric">{{(tr[cl.title])? getFixed(tr[cl.title]): '-'}}</span>
                      <span v-else>{{(tr[cl.title])? getChecknFixed(tr[cl.title]): '-'}}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
              <tr v-if="rawData.length===0">
                <td>
                  <div class="alert alert-danger" role="alert">No data found!</div>
                </td>
              </tr>
            </table>
          </div>
          <div class="row">
            <div class="col-md-7"></div>
            <div class="col-md-5">
              <div class="pull-right">
                <ul v-if="totalPages != 1" class="pagination">
                  <li :class="{disabled:prevDisabled}" class="page-item">
                    <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
                  </li>
                  <li :class="{disabled:prevDisabled}" class="page-item">
                    <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
                  </li>
                  <li
                    v-for="page in pages"
                    v-bind:key="page"
                    class="page-item"
                    :class="(current_page == page)? 'active':''"
                  >
                    <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
                  </li>
                  <li :class="{disabled:nextDisabled}" class="page-item">
                    <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
                  </li>
                  <li :class="{disabled:nextDisabled}" class="page-item">
                    <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
</template>
<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";

import http from "@/lib/http";

import { commonMixins } from "../../../assets/mixins/common.js";
import { rawMixins } from "../../../assets/mixins/rawMixins.js";

// import Issues from "@/views/tableFields/rawData/issues";

export default {
  // props: ["issuesData", "comp", "rawDataType", "tableFields", "rows"],
  mixins: [commonMixins, rawMixins],
  components: { VueTabs, VTab },
  created() {
    if (!localStorage.getItem("orawtab")) {
      this.rawDataType = this.rawDataList[this.selRowInd].id;
      // this.oselTab = this.rawDataList[this.selRowInd].value;
      localStorage.setItem("orawtab", this.rawDataType);
      localStorage.setItem("oselTab", this.oselTab);
      this.getRawData();
    } else {
      this.rawDataType = localStorage.getItem("orawtab");
      if (localStorage.getItem("oselTab") !== "Industries") {
        this.oselTab = localStorage.getItem("oselTab");
      } else {
        this.getRawData();
      }
    }
  },
  methods: {
    getRawData() {
      this.rawData = [];
      this.tableFields = [];
      (this.companies = []),
        (this.selectedCompanies = []),
        (this.isCompSel = true),
        (this.isCompared = false);
      let myself = this;
      http.post(
        this.rawDataApi,
        { rowFieldName: myself.rawDataType, co_code: 0, page_id: myself.page },
        (error, response) => {
          if (this.rawDataType === "sectors") {
            this.rawData = response.data.splice(1);
          } else {
            this.rawData = response.data;
          }
          myself.totalPages = response.total_pages ? response.total_pages : 1;
          let i = 8;
          let page = myself.current_page - 2;
          if (page <= 0) page = 1;
          myself.pages = [];
          while (i) {
            myself.pages.push(parseInt(page));
            if (myself.totalPages <= page) break;
            page++;
            i--;
          }
          this.setTableValues();
          console.log("this.rawData", this.rawData);
          this.rawDataList[this.selRowInd].items = this.rawData;
          //TODO:: add tableFields updates into our array in future
        }
      );
    },
    setTableValues() {
      this.downLoadableData = [];
      this.tableFields = [];
      console.log(this.rawDataType);
      if (this.rawDataType === "companies") {
        this.tableRows = [];
        this.tableFields = [];
        // if (this.rawData.length > 0) {
        //   var rowKeys = Object.keys(this.rawData[0]);
        //   rowKeys.forEach((val, key) => {
        //     console.log("Rows", key, val);
        //     if (val !== "sno" && val !== "_id" && val !== "sectorcode" && val !== "industrycode" && val !== "companyshortname" && val !== "nsesymbol") {

        //       this.tableFields.push({
        //         title: val,
        //         name: this.getCustomLabel(val)
        //           ? this.getCustomLabel(val)
        //           : this.getLabel(val),
        //         sort_order:
        //           val === "co_code"
        //             ? 1
        //             : val === "bsecode"
        //             ? 2
        //             : val === "nsesymbol"
        //             ? 3
        //             : val === "companyname"
        //             ? 4
        //             : val === "companyshortname"
        //             ? 5
        //             : val === "categoryname"
        //             ? 6
        //             : val === "isin"
        //             ? 7
        //             : val === "bsegroup"
        //             ? 8
        //             : val === "mcaptype"
        //             ? 9
        //             : val === "sectorcode"
        //             ? 10
        //             : val === "sectorname"
        //             ? 11
        //             : val === "govtflag"
        //             ? 12
        //             : 99
        //       });
        //     }
        //   });
        //   this.tableFields = this.sorted_fields_asc(
        //     this.tableFields,
        //     "sort_order"
        //   );
        // }
        this.tableFields = [
          { title: "co_code", name: "Code", sort_order: 1 },
          { title: "companyname", name: "Company", sort_order: 2 },
          { title: "categoryname", name: "Category", sort_order: 3 },
          { title: "isin", name: "ISIN", sort_order: 4 },
          { title: "mcaptype", name: "MCap Type", sort_order: 5 },
          { title: "sectorname", name: "Sector", sort_order: 6 },
          { title: "govtflag", name: "Is Public Sector", sort_order: 7 }
          // {title: "co_code",
          // name: this.getCustomLabel("co_code")? this.getCustomLabel("co_code"): this.getLabel("co_code"),
          // sort_order: 8},
          // {title: "co_code",
          // name: this.getCustomLabel("co_code")? this.getCustomLabel("co_code"): this.getLabel("co_code"),
          // sort_order: 9},
          // {title: "co_code",
          // name: this.getCustomLabel("co_code")? this.getCustomLabel("co_code"): this.getLabel("co_code"),
          // sort_order: 10},
        ];
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "name_change") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "xdate" ? "date" : "",
                sort_order:
                  val === "co_code"
                    ? 1
                    : val === "sc_code"
                    ? 2
                    : val === "symbol"
                    ? 3
                    : val === "oldname"
                    ? 4
                    : val === "newname"
                    ? 5
                    : val === "xdate"
                    ? 6
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        this.rawData = this.sorted_fields_date(this.rawData, "xdate");
        console.log(this.tableRows, this.tableFields, this.rawData);
      } else if (this.rawDataType === "sectors") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type:
                  val === "financial" ||
                  val === "medical" ||
                  val === "service" ||
                  val === "technology" ||
                  val === "utility/telecom/railroad"
                    ? "boolean"
                    : "",
                sort_order:
                  val === "sect_code"
                    ? 1
                    : val === "sect_name"
                    ? 2
                    : val === "financial"
                    ? 3
                    : val === "medical"
                    ? 4
                    : val === "service"
                    ? 5
                    : val === "technology"
                    ? 6
                    : val === "utility/telecom/railroad"
                    ? 7
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "sast") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "REPEXCH" ? "date" : "",
                sort_order:
                  val === "CO_CODE"
                    ? 1
                    : val === "CO_NAME"
                    ? 2
                    : val === "PERSONNAME"
                    ? 3
                    : val === "PROMOTER"
                    ? 4
                    : val === "TRANSPEROD"
                    ? 5
                    : val === "ACQSALE"
                    ? 6
                    : val === "MODEBUYearSAL"
                    ? 7
                    : val === "NOOFSHARES"
                    ? 8
                    : val === "PERCSHARES"
                    ? 9
                    : val === "HOLDQUANT"
                    ? 10
                    : val === "HOLDPTCAP"
                    ? 11
                    : val === "HOLDPDCAP"
                    ? 12
                    : val === "REGULATION"
                    ? 13
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "REPEXCH");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "industry_master") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "BSEDate" ? "date" : "",
                sort_order:
                  val === "IndustryCode" ? 1 : val === "IndustryName" ? 2 : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields);
      } else if (
        this.rawDataType === "IndexWiseCompanyList_bse" ||
        this.rawDataType === "IndexWiseCompanyList_nse"
      ) {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "BSEDate" ? "date" : "",
                sort_order:
                  val === "co_code"
                    ? 1
                    : val === "lname"
                    ? 2
                    : val === "index_code"
                    ? 3
                    : val === "index_name"
                    ? 4
                    : val === "sc_code"
                    ? 5
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Year_End_Master") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "BSEDate" ? "date" : "",
                sort_order:
                  val === "co_code" ? 1 : val === "yearendmonth" ? 2 : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields);
      } else if (
        this.rawDataType === "exchange_holidays_bse" ||
        this.rawDataType === "exchange_holidays_nse"
      ) {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "holidaydate" ? "date" : "",
                sort_order: val === "holidaydate" ? 1 : val === "day" ? 2 : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields);
      } else if (
        this.rawDataType === "book_closure_bse" ||
        this.rawDataType === "book_closure_nse"
      ) {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "StartDate" || val === "EndDate" ? "date" : "",
                sort_order:
                  val === "co_code"
                    ? 1
                    : val === "ComapnyName"
                    ? 2
                    : val === "symbol"
                    ? 2
                    : val === "StartDate"
                    ? 2
                    : val === "EndDate"
                    ? 2
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "StartDate");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (
        this.rawDataType === "fifty_two_week_high_bse" ||
        this.rawDataType === "fifty_two_week_high_nse" ||
        this.rawDataType === "fifty_two_week_low_bse" ||
        this.rawDataType === "fifty_two_week_low_nse"
      ) {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (
              val !== "_id" &&
              val !== "sc_code" &&
              val !== "isin" &&
              val !== "symbol" &&
              val !== "sect_code"
            ) {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type:
                  val === "prev_BSE52WHighDate" ||
                  val === "prev_NSE52WHighDate" ||
                  val === "prev_BSE52WLowDate" ||
                  val === "prev_NSE52WLowDate"
                    ? "date"
                    : "",
                sort_order:
                  val === "co_code"
                    ? 1
                    : val === "CompanyName"
                    ? 2
                    : val === "sect_name"
                    ? 3
                    : val === "Price"
                    ? 4
                    : val === "prev_BSE52WHigh" ||
                      val === "prev_NSE52WHigh" ||
                      val === "prev_BSE52WLow" ||
                      val === "prev_NSE52WLow"
                    ? 5
                    : val === "prev_BSE52WHighDate" ||
                      val === "prev_BSE52WLowDate" ||
                      val === "prev_NSE52WHighDate" ||
                      val === "prev_NSE52WLowDate"
                    ? 6
                    : val === "currmcap"
                    ? 7
                    : val === "high"
                    ? 8
                    : val === "low"
                    ? 9
                    : val === "volume"
                    ? 10
                    : val === "chg"
                    ? 11
                    : val === "pchange"
                    ? 12
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          if (this.rawDataType === "fifty_two_week_high_bse") {
            this.rawData = this.sorted_fields_date(
              this.rawData,
              "prev_BSE52WHighDate"
            );
          } else if (this.rawDataType === "fifty_two_week_high_nse") {
            this.rawData = this.sorted_fields_date(
              this.rawData,
              "prev_BSE52WHighDate"
            );
          } else if (this.rawDataType === "fifty_two_week_low_bse") {
            this.rawData = this.sorted_fields_date(
              this.rawData,
              "prev_BSE52WLowDate"
            );
          } else if (this.rawDataType === "fifty_two_week_low_nse") {
            this.rawData = this.sorted_fields_date(
              this.rawData,
              "prev_NSE52WLowDate"
            );
          }
        }
        console.log(this.tableRows, this.tableFields);
      } else if (
        this.rawDataType === "Open_Issues" ||
        this.rawDataType === "Closed_Issues" ||
        this.rawDataType === "new_issues_monitor"
      ) {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "co_code" && val !== "sno" && val !== "_id") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "OPENDATE" || val === "CLOSDATE" ? "date" : "",
                sort_order:
                  val === "lname"
                    ? 1
                    : val === "ISSUETYPE"
                    ? 2
                    : val === "ISSUESIZE"
                    ? 3
                    : val === "Offer_Price"
                    ? 4
                    : val === "OPENDATE"
                    ? 5
                    : val === "CLOSDATE"
                    ? 5
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        this.rawData = this.sorted_fields_date(this.rawData, "OPENDATE");
        console.log(this.tableRows, this.tableFields);
      } else if (
        this.rawDataType === "sector_watch_bse" ||
        this.rawDataType === "sector_watch_nse"
      ) {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "stk_exchng") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "upddate" ? "date" : "",
                sort_order:
                  val === "sc_code"
                    ? 1
                    : val === "co_code"
                    ? 2
                    : val === "complongname"
                    ? 3
                    : val === "close_price"
                    ? 4
                    : val === "netchg"
                    ? 5
                    : val === "perchg"
                    ? 5
                    : val === "prevclose"
                    ? 5
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        this.rawData = this.sorted_fields_date(this.rawData, "upddate");
        console.log(this.tableRows, this.tableFields);
      } else if (
        this.rawDataType === "new_listing_BSE" ||
        this.rawDataType === "new_listing_NSE" ||
        this.rawDataType === "best_performance_BSE" ||
        this.rawDataType === "best_performance_NSE"
      ) {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "co_code" && val !== "sno" && val !== "_id") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val == "LastTr_Date" || val === "IssueDate" ? "date" : "",
                sort_order:
                  val === "sc_code" || val === "code"
                    ? 0
                    : val === "co_code"
                    ? 1
                    : val === "lname"
                    ? 2
                    : val === "CO_NAME"
                    ? 3
                    : val === "LISTDATE"
                    ? 4
                    : val === "listprice"
                    ? 5
                    : val === "LISTVOL"
                    ? 7
                    : val === "IssueSize"
                    ? 8
                    : val === "OfferPrice"
                    ? 9
                    : val === "HIGH"
                    ? 10
                    : val === "LOW"
                    ? 11
                    : val === "CLOSE"
                    ? 12
                    : val === "VOLUME"
                    ? 13
                    : val === "LastTr_Date"
                    ? 14
                    : val === "PerChange"
                    ? 15
                    : val === "IssueDate"
                    ? 16
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        this.rawData = this.sorted_fields_date(this.rawData, "DATE");
        console.log(this.tableRows, this.tableFields);
      } else if (
        this.rawDataType === "under_performers_bse" ||
        this.rawDataType === "under_performers_nse" ||
        this.rawDataType === "out_performers_bse" ||
        this.rawDataType === "out_performers_nse"
      ) {
        if (this.rawData.length !== 0) {
          this.tableFields.push(
            {
              title: "co_code",
              name: "Company Code",
              rowind: "1",
              sort_order: 0,
              isNumeric: false
            },
            {
              title: "co_name",
              name: "Company Name",
              rowind: "1",
              sort_order: 0,
              isNumeric: false
            },
            {
              title: "closedate",
              name: "Close Date",
              rowind: "1",
              sort_order: 1,
              isNumeric: false,
              type: "date"
            },
            {
              title: "close",
              name: "Close Price",
              rowind: "1",
              sort_order: 2,
              isNumeric: true
            },
            {
              title: "closedate1",
              name: "Prev Close Date",
              rowind: "1",
              sort_order: 3,
              isNumeric: false,
              type: "date"
            },
            {
              title: "close1",
              name: "Prev Close Price",
              rowind: "1",
              sort_order: 4,
              isNumeric: true
            },
            {
              title: "diff",
              name: "Diff",
              rowind: "1",
              sort_order: 5,
              isNumeric: true
            },
            {
              title: "perchg",
              name: "Percentage Change",
              rowind: "1",
              sort_order: 6,
              isNumeric: true
            },
            {
              title: "opval",
              name: "OP Val",
              rowind: "1",
              sort_order: 7,
              isNumeric: true
            }
          );
          this.rawData = this.sorted_fields_date(this.rawData, "closedate");
        }
      } else if (
        this.rawDataType === "unusual_volume_bse_down" ||
        this.rawDataType === "unusual_volume_nse_down" ||
        this.rawDataType === "unusual_volume_bse_up" ||
        this.rawDataType === "unusual_volume_nse_up"
      ) {
        if (this.rawData.length !== 0) {
          this.tableFields.push(
            {
              title: "co_code",
              name: "Company code",
              rowind: "1",
              sort_order: 1,
              isNumeric: false
            },
            {
              title: "co_name",
              name: "Company Name",
              rowind: "1",
              sort_order: 2,
              isNumeric: false
            },
            {
              title:
                this.rawDataType === "unusual_volume_bse_up" ||
                this.rawDataType === "unusual_volume_bse_down"
                  ? "stk_exchange"
                  : this.rawDataType === "unusual_volume_nse_up" ||
                    this.rawDataType === "unusual_volume_bse_up"
                  ? "stk_exchng"
                  : "",
              name: "Exchange Name",
              rowind: "1",
              sort_order: 3,
              isNumeric: false
            },
            {
              title: "sc_code",
              name: "BSE Script Code",
              rowind: "1",
              sort_order: 4,
              isNumeric: false
            },
            {
              title: "symbol",
              name: "NSE Company Symbol",
              rowind: "1",
              sort_order: 5,
              isNumeric: false
            },
            {
              title: "sc_group",
              name: "Scrip Group",
              rowind: "1",
              sort_order: 6,
              isNumeric: false
            },
            {
              title: "open_price",
              name: "Open Price",
              rowind: "1",
              sort_order: 7,
              isNumeric: true
            },
            {
              title: "high_price",
              name: "High Price",
              rowind: "1",
              sort_order: 8,
              isNumeric: true
            },
            {
              title: "low_price",
              name: "Low Price",
              rowind: "1",
              sort_order: 9,
              isNumeric: true
            },
            {
              title: "close_price",
              name: "Close Price",
              rowind: "1",
              sort_order: 10,
              isNumeric: true
            },
            {
              title: "bbuy_qty",
              name: "Best Buy Quantity",
              rowind: "1",
              sort_order: 11,
              isNumeric: false
            },
            {
              title: "bbuy_price",
              name: "Best Buy Price",
              rowind: "1",
              sort_order: 12,
              isNumeric: true
            },
            {
              title: "bsell_qty",
              name: "Best Sell Quantity",
              rowind: "1",
              sort_order: 13,
              isNumeric: false
            },
            {
              title: "bsell_price",
              name: "Best Sell Price",
              rowind: "1",
              sort_order: 14,
              isNumeric: true
            },
            {
              title: "prevclose",
              name: "Previous Close",
              rowind: "1",
              sort_order: 15,
              isNumeric: true
            },
            {
              title: "prevdate",
              name: "Previous Date",
              rowind: "1",
              sort_order: 16,
              isNumeric: false,
              type: "date"
            },
            {
              title: "vol_traded",
              name: "Percentage Change",
              rowind: "1",
              sort_order: 17,
              isNumeric: false
            },
            {
              title: "pervol",
              name: "Net Change",
              rowind: "1",
              sort_order: 18,
              isNumeric: false
            },
            {
              title: "perchg",
              name: "Volume Traded",
              rowind: "1",
              sort_order: 19,
              isNumeric: false
            },
            {
              title: "netchg",
              name: "Percentage Volume",
              rowind: "1",
              sort_order: 20,
              isNumeric: false
            },
            {
              title: "val_traded",
              name: "Value Traded",
              rowind: "1",
              sort_order: 21,
              isNumeric: false
            },
            {
              title: "fiftytwoweekhigh",
              name: "52 Week High",
              rowind: "1",
              sort_order: 22,
              isNumeric: false
            },
            {
              title: "fiftytwoweeklow",
              name: "52 Week Low",
              rowind: "1",
              sort_order: 23,
              isNumeric: false
            },
            {
              title: "prev_vol_traded",
              name: "Previous Volume Traded",
              rowind: "1",
              sort_order: 24,
              isNumeric: false
            },
            {
              title: "prev_value_traded",
              name: "Previous Value Traded",
              rowind: "1",
              sort_order: 25,
              isNumeric: false
            }
          );
          this.rawData = this.sorted_fields_date(this.rawData, "prevdate");
        }
      } else if (
        this.rawDataType === "bulk_deals_bse" ||
        this.rawDataType === "bulk_deals_nse" ||
        this.rawDataType === "block_deals_bse" ||
        this.rawDataType === "block_deals_nse"
      ) {
        if (this.rawData.length !== 0) {
          this.tableFields.push(
            {
              title: "date",
              name: "Date",
              rowind: "1",
              sort_order: 0,
              isNumeric: false,
              type: "date"
            },
            {
              title: "co_code",
              name: "Company Code",
              rowind: "1",
              sort_order: 1,
              isNumeric: false
            },
            {
              title: "serial",
              name: "Sr no. wrt script code",
              rowind: "1",
              sort_order: 2,
              isNumeric: false
            },
            {
              title: "scripcode",
              name: "Script Code",
              rowind: "1",
              sort_order: 3,
              isNumeric: false
            },
            {
              title: "scripname",
              name: "Script",
              rowind: "1",
              sort_order: 4,
              isNumeric: false
            },
            {
              title: "clientname",
              name: "Client",
              rowind: "1",
              sort_order: 5,
              isNumeric: false
            },
            {
              title: "buysell",
              name: "Buy Sell",
              rowind: "1",
              sort_order: 6,
              isNumeric: false
            },
            {
              title: "qtyshares",
              name: "Qty Shares",
              rowind: "1",
              sort_order: 7,
              isNumeric: false
            },
            {
              title: "avg_price",
              name: "Avg Price",
              rowind: "1",
              sort_order: 8,
              isNumeric: true
            }
          );
          this.rawData = this.sorted_fields_date(this.rawData, "date");
        }
      } else if (
        this.rawDataType === "ticker_bse" ||
        this.rawDataType === "ticker_nse"
      ) {
        console.log(this.rawData);
        if (this.rawData.length !== 0) {
          this.tableFields.push(
            {
              title: "co_code",
              name: "Company Code",
              rowind: "1",
              sort_order: 0,
              isNumeric: false
            },
            {
              title: "co_name",
              name: "Company",
              rowind: "1",
              sort_order: 0,
              isNumeric: false
            },
            {
              title: "price",
              name: "Current Price",
              rowind: "1",
              sort_order: 1,
              isNumeric: false
            },
            {
              title: "price_diff",
              name: "Price diff",
              rowind: "1",
              sort_order: 2,
              isNumeric: false
            },
            {
              title: "tr_date",
              name: "Traded Date",
              rowind: "1",
              sort_order: 3,
              isNumeric: false,
              type: "date"
            },
            {
              title: "change",
              name: "% Change",
              rowind: "1",
              sort_order: 4,
              isNumeric: true
            },
            {
              title: "open_price",
              name: "Open Price",
              rowind: "1",
              sort_order: 5,
              isNumeric: true
            },
            {
              title: "high_price",
              name: "High Price",
              rowind: "1",
              sort_order: 6,
              isNumeric: true
            },
            {
              title: "low_price",
              name: "Low Price",
              rowind: "1",
              sort_order: 7,
              isNumeric: true
            }
          );
          this.rawData = this.sorted_fields_date(this.rawData, "tr_date");
        }
      } else if (
        this.rawDataType === "BetaAndvolatilityStockWise_bse" ||
        this.rawDataType === "BetaAndvolatilityStockWise_nse"
      ) {
        console.log(this.rawData);
        if (this.rawData.length !== 0) {
          this.tableFields.push(
            {
              title: "CO_CODE",
              name: "Company Code",
              rowind: "1",
              sort_order: 0,
              isNumeric: false
            },
            {
              title: "SD",
              name: "SD",
              rowind: "1",
              sort_order: 0,
              isNumeric: true
            },
            {
              title: "Beta",
              name: "Beta",
              rowind: "1",
              sort_order: 1,
              isNumeric: true
            }
          );
          // this.rawData = this.sorted_fields_date(this.rawData, "tr_date");
        }
      } else if (this.rawDataType === "capital_market_live_news") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (
              val !== "sno" &&
              val !== "co_code" &&
              val !== "_id" &&
              val !== "caption" &&
              val !== "ind_code" &&
              val !== "flag"
            ) {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "date" ? "date" : "",
                sort_order:
                  val === "heading"
                    ? 1
                    : val === "section_name"
                    ? 2
                    : val === "arttext"
                    ? 3
                    : val === "date"
                    ? 4
                    : val === "time"
                    ? 5
                    : 99
              });
            }
            this.rawData = this.sorted_fields_date(this.rawData, "date");
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "market_turnover") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "_id") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "date" ? "date" : "",
                sort_order:
                  val === "date"
                    ? 1
                    : val === "turnov_bse"
                    ? 2
                    : val === "turnov_nse"
                    ? 3
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "date");
        }
        console.log(this.tableRows, this.tableFields);
      }
      console.log("tableFields", this.tableFields);
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log(
        "TabChange",
        this.oselTab,
        oldTab.title,
        this.oselTab === oldTab.title,
        tabIndex,
        newTab,
        oldTab
      );
      this.clearPagination();
      if (this.oselTab !== oldTab.title) {
        this.rawDataList[this.selRowInd].open = false;
        this.selRowInd = tabIndex;
        this.rawDataList[tabIndex].open = !this.rawDataList[tabIndex].open;
        this.rawDataType = this.rawDataList[tabIndex].id;
        this.oselTab = this.rawDataList[tabIndex].value;
        localStorage.setItem("orawtab", this.rawDataList[tabIndex].id);
        localStorage.setItem("oselTab", this.rawDataList[tabIndex].value);
        this.getRawData();
      } else if (this.oselTab === oldTab.title) {
        this.selRowInd = tabIndex;
        this.rawDataList[tabIndex].open = !this.rawDataList[tabIndex].open;
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.prevDisabled = 0;
      this.fillTable();
    },
    fillTable() {
      this.page = this.pageToLoad;
      if (this.pageToLoad == this.totalPages) {
        this.nextDisabled = 1;
      } else {
        this.nextDisabled = 0;
      }
      if (this.pageToLoad == 1) {
        this.prevDisabled = 1;
      } else {
        this.prevDisabled = 0;
      }
      this.current_page = this.pageToLoad;
      this.getRawData();
    },
    clearPagination() {
      this.page = 1;
      this.current_page = 1;
      this.pageToLoad = 1;
      this.totalPages = 1;
      this.prevDisabled = 1;
      this.nextDisabled = 0;
      this.pages = [];
    }
  },
  data() {
    return {
      page: 1,
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      company: { co_code: 0, companyname: "" },
      rawDataList: [
        { id: "industry_master", value: "Industries", items: {} },
        {
          id: "IndexWiseCompanyList_bse",
          value: "Index wise company list BSE",
          items: {}
        },
        {
          id: "IndexWiseCompanyList_nse",
          value: "Index wise company list NSE",
          items: {}
        },
        { id: "sectors", value: "Sectors", items: {} },
        { id: "companies", value: "Companies", items: {} },
        { id: "name_change", value: "Name Changes", items: {} },
        { id: "Year_End_Master", value: "Year end Master", items: {} },
        { id: "exchange_holidays_bse", value: "Holidays BSE", items: {} },
        { id: "exchange_holidays_nse", value: "Holidays NSE", items: {} },
        { id: "book_closure_bse", value: "Book Closure BSE", items: {} },
        { id: "book_closure_nse", value: "Book Closure NSE", items: {} },
        { id: "fifty_two_week_high_bse", value: "52 Week High BSE", items: {} },
        { id: "fifty_two_week_high_nse", value: "52 Week High NSE", items: {} },
        { id: "fifty_two_week_low_bse", value: "52 Week Low BSE", items: {} },
        { id: "fifty_two_week_low_nse", value: "52 Week Low NSE", items: {} },
        { id: "market_turnover", value: "Market Turnover", items: {} },
        { id: "sast", value: "SAST", items: {} },
        // { id: "latest_mcap_price_os", value: "Latest Price MCAP Shares", items: {} },
        { id: "under_performers_bse", value: "Under Performer BSE", items: {} },
        { id: "under_performers_nse", value: "Under Performer NSE", items: {} },
        { id: "out_performers_bse", value: "Out Performer BSE", items: {} },
        { id: "out_performers_nse", value: "Out Performer NSE", items: {} },
        {
          id: "unusual_volume_bse_down",
          value: this.getLabel("unusual_volume_bse_down"),
          items: {}
        },
        {
          id: "unusual_volume_bse_up",
          value: this.getLabel("unusual_volume_bse_up"),
          items: {}
        },
        {
          id: "unusual_volume_nse_down",
          value: this.getLabel("unusual_volume_nse_down"),
          items: {}
        },
        {
          id: "unusual_volume_nse_up",
          value: this.getLabel("unusual_volume_nse_up"),
          items: {}
        },
        {
          id: "bulk_deals_bse",
          value: this.getLabel("bulk_deals_bse"),
          items: {}
        },
        {
          id: "bulk_deals_nse",
          value: this.getLabel("bulk_deals_nse"),
          items: {}
        },
        {
          id: "block_deals_bse",
          value: this.getLabel("block_deals_bse"),
          items: {}
        },
        {
          id: "block_deals_nse",
          value: this.getLabel("block_deals_nse"),
          items: {}
        },
        { id: "ticker_bse", value: this.getLabel("ticker_bse"), items: {} },
        { id: "ticker_nse", value: this.getLabel("ticker_nse"), items: {} },
        {
          id: "Open_Issues",
          value: "Open Issues",
          open: false,
          items: {}
        },
        {
          id: "Closed_Issues",
          value: "Closed Issues",
          open: false,
          items: {}
        },
        {
          id: "new_issues_monitor",
          value: "New Issues Monitor",
          open: false,
          items: {}
        },
        {
          id: "new_listing_BSE",
          value: "New Listing BSE",
          open: false,
          items: {}
        },
        {
          id: "new_listing_NSE",
          value: "New Listing NSE",
          open: false,
          items: {}
        },
        {
          id: "best_performance_BSE",
          value: "Best Performance BSE",
          open: false,
          items: {}
        },
        {
          id: "best_performance_NSE",
          value: "Best Performance NSE",
          open: false,
          items: {}
        },
        {
          id: "sector_watch_bse",
          value: "Sector Watch BSE",
          open: false,
          items: {}
        },
        {
          id: "sector_watch_nse",
          value: "Sector Watch NSE",
          open: false,
          items: {}
        },
        {
          id: "BetaAndvolatilityStockWise_bse",
          value: "Beta & Volatility BSE",
          open: false,
          items: {}
        },
        {
          id: "BetaAndvolatilityStockWise_nse",
          value: "Beta & Volatility NSE",
          open: false,
          items: {}
        },
        {
          id: "capital_market_live_news",
          value: "Capital Market Live News",
          open: false,
          items: {}
        }
      ],
      rawDataType: "sectors",
      rawDataApi: "rawDataList",
      selRowInd: 0,
      oselTab: "",
      tableFields: [],
      tableRows: [],
      rawData: []
    };
  },
  watch: {
    issuesData: function(value) {
      console.log(this.issuesData, value);
      this.rawData = value;
    }
  },
  computed: {
    mfHoldingData: function() {
      return this.rawData.filter(function(row, index) {
        return index !== "_id" && index !== "co_code";
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/company/rawdata/overallRawData.vue